<template>
  <a-breadcrumb class="m-breadcrumb">
    <a-breadcrumb-item>
      <a href="/" v-if="isHome">首页</a>
      <span v-else>首页</span>
    </a-breadcrumb-item>
    <a-breadcrumb-item v-if="isHome">{{getTitle}}</a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { routes } from '@/router';

export default {
  data() {
    return {
      middleRoute: {},
    };
  },
  computed: {
    isHome() {
      return this.$route.name !== 'home.index';
    },
    getTitle() {
      const name = this.$route.name;
      const route = this.$route;
      const { id, customer_id } = route.params;
      if (!name) return '';
      if (name.includes('add')) {
        // console.log()
        if (id || customer_id) return `编辑${route.meta.title}`;
        else return `新增${route.meta.title}`;
      }
      return route.meta.title;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb.vue